import { ReactNode, useEffect } from "react"
import EmbeddedChessScreen from "@/components/game/EmbeddedChessScreen"
import { GameProvider } from "@/hooks/useGame"
import { GameMovesProvider } from "@/hooks/useGameMoves"
import axios from "axios"
import { usePage } from "@inertiajs/react"
import { GameShowProps } from "@/types/types"

let didTrack = false

const EmbedShow = () => {
  const { game } = usePage<GameShowProps>().props

  useEffect(() => {
    if (!game.id) return
    if (didTrack) return

    didTrack = true
    ;(async () => {
      try {
        const url =
          window?.location?.ancestorOrigins?.[0] ?? document?.referrer ?? null

        let hostname = null

        try {
          hostname = url ? new URL(url).hostname : null
        } catch {
          hostname = null
        }

        axios.post("/api/embed_views", {
          game_id: game.id,
          host: hostname,
        })
      } catch (error) {
        console.log(error)
        console.error("Failed to track page view:", error)
      }
    })()
  }, [game.id])

  useEffect(
    () =>
      document
        .getElementById("app")
        ?.classList.add("border-2", "border-gray-300", "bg-gray-50"),
    []
  )

  return (
    <GameMovesProvider>
      <GameProvider>
        <EmbeddedChessScreen />
      </GameProvider>
    </GameMovesProvider>
  )
}

export default EmbedShow

EmbedShow.layout = (page: ReactNode) => page
